export const countries = [
	{
		code: 'AF',
		name: 'Afganistán',
		regions: [
			{ name: 'Kabul', cities: ['Kabul', 'Charikar'] },
			{ name: 'Herat', cities: ['Herat', 'Ghoriyan'] },
		],
	},
	{
		code: 'AR',
		name: 'Argentina',
		regions: [
			{ name: 'Buenos Aires', cities: ['Buenos Aires', 'La Plata', 'Mar del Plata'] },
			{ name: 'Córdoba', cities: ['Córdoba', 'Villa María'] },
			{ name: 'Santa Fe', cities: ['Rosario', 'Santa Fe'] },
		],
	},
	{
		code: 'BO',
		name: 'Bolivia',
		regions: [
			{ name: 'La Paz', cities: ['La Paz', 'El Alto'] },
			{ name: 'Santa Cruz', cities: ['Santa Cruz de la Sierra', 'Montero'] },
		],
	},
	{
		code: 'BR',
		name: 'Brasil',
		regions: [
			{ name: 'São Paulo', cities: ['São Paulo', 'Campinas', 'Santos'] },
			{ name: 'Rio de Janeiro', cities: ['Rio de Janeiro', 'Niterói'] },
		],
	},
	{
		code: 'CL',
		name: 'Chile',
		regions: [
			{ name: 'Región Metropolitana', cities: ['Santiago', 'Puente Alto'] },
			{ name: 'Valparaíso', cities: ['Valparaíso', 'Viña del Mar'] },
		],
	},
	{
		code: 'CO',
		name: 'Colombia',
		regions: [
			{ name: 'Antioquia', cities: ['Medellín', 'Bello', 'Envigado'] },
			{ name: 'Cundinamarca', cities: ['Bogotá', 'Soacha', 'Zipaquirá'] },
			{ name: 'Valle del Cauca', cities: ['Cali', 'Palmira', 'Buenaventura'] },
		],
	},
	{
		code: 'CR',
		name: 'Costa Rica',
		regions: [
			{ name: 'San José', cities: ['San José', 'Escazú'] },
			{ name: 'Alajuela', cities: ['Alajuela', 'San Ramón'] },
		],
	},
	{
		code: 'CU',
		name: 'Cuba',
		regions: [
			{ name: 'La Habana', cities: ['La Habana', 'Marianao'] },
			{ name: 'Santiago de Cuba', cities: ['Santiago de Cuba', 'Palma Soriano'] },
		],
	},
	{
		code: 'DO',
		name: 'República Dominicana',
		regions: [
			{ name: 'Santo Domingo', cities: ['Santo Domingo', 'Los Alcarrizos'] },
			{ name: 'Santiago', cities: ['Santiago de los Caballeros', 'Puñal'] },
		],
	},
	{
		code: 'EC',
		name: 'Ecuador',
		regions: [
			{ name: 'Pichincha', cities: ['Quito', 'Sangolquí'] },
			{ name: 'Guayas', cities: ['Guayaquil', 'Durán'] },
		],
	},
	{
		code: 'SV',
		name: 'El Salvador',
		regions: [
			{ name: 'San Salvador', cities: ['San Salvador', 'Soyapango'] },
			{ name: 'La Libertad', cities: ['Santa Tecla', 'Antiguo Cuscatlán'] },
		],
	},
	{
		code: 'ES',
		name: 'España',
		regions: [
			{ name: 'Madrid', cities: ['Madrid', 'Móstoles', 'Alcalá de Henares'] },
			{ name: 'Cataluña', cities: ['Barcelona', 'Tarragona', 'Girona'] },
			{ name: 'Andalucía', cities: ['Sevilla', 'Málaga', 'Granada'] },
		],
	},
	{
		code: 'GT',
		name: 'Guatemala',
		regions: [
			{ name: 'Guatemala', cities: ['Ciudad de Guatemala', 'Mixco'] },
			{ name: 'Quetzaltenango', cities: ['Quetzaltenango', 'Coatepeque'] },
		],
	},
	{
		code: 'HN',
		name: 'Honduras',
		regions: [
			{ name: 'Francisco Morazán', cities: ['Tegucigalpa', 'Comayagüela'] },
			{ name: 'Cortés', cities: ['San Pedro Sula', 'Choloma'] },
		],
	},
	{
		code: 'MX',
		name: 'México',
		regions: [
			{ name: 'Ciudad de México', cities: ['Ciudad de México', 'Iztapalapa'] },
			{ name: 'Jalisco', cities: ['Guadalajara', 'Zapopan', 'Tlaquepaque'] },
			{ name: 'Nuevo León', cities: ['Monterrey', 'San Nicolás', 'Guadalupe'] },
		],
	},
	{
		code: 'NI',
		name: 'Nicaragua',
		regions: [
			{ name: 'Managua', cities: ['Managua', 'Ciudad Sandino'] },
			{ name: 'León', cities: ['León', 'Nagarote'] },
		],
	},
	{
		code: 'PA',
		name: 'Panamá',
		regions: [
			{ name: 'Panamá', cities: ['Ciudad de Panamá', 'San Miguelito'] },
			{ name: 'Colón', cities: ['Colón', 'Sabanitas'] },
		],
	},
	{
		code: 'PY',
		name: 'Paraguay',
		regions: [
			{ name: 'Central', cities: ['Asunción', 'San Lorenzo'] },
			{ name: 'Alto Paraná', cities: ['Ciudad del Este', 'Presidente Franco'] },
		],
	},
	{
		code: 'PE',
		name: 'Perú',
		regions: [
			{ name: 'Lima', cities: ['Lima', 'Callao', 'San Juan de Lurigancho'] },
			{ name: 'Arequipa', cities: ['Arequipa', 'Cayma'] },
		],
	},
	{
		code: 'PR',
		name: 'Puerto Rico',
		regions: [
			{ name: 'San Juan', cities: ['San Juan', 'Bayamón'] },
			{ name: 'Ponce', cities: ['Ponce', 'Juana Díaz'] },
		],
	},
	{
		code: 'UY',
		name: 'Uruguay',
		regions: [
			{ name: 'Montevideo', cities: ['Montevideo', 'Ciudad de la Costa'] },
			{ name: 'Canelones', cities: ['Las Piedras', 'Pando'] },
		],
	},
	{
		code: 'VE',
		name: 'Venezuela',
		regions: [
			{ name: 'Distrito Capital', cities: ['Caracas', 'Chacao'] },
			{ name: 'Zulia', cities: ['Maracaibo', 'San Francisco'] },
		],
	},
]
